import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

function withStoryblok(WrappedComponent, blockSlug, ...additionalStores) {
  const ObserverComponent = observer(WrappedComponent);

  class StoryblokWrapper extends Component {
    constructor(props) {
      super(props);
      const { contentStore } = props;
      contentStore.currentPage = blockSlug;
    }

    componentDidMount() {
      const { contentStore } = this.props;
      contentStore.fetchBlock(blockSlug);
    }

    render() {
      return <ObserverComponent {...this.props} />;
    }
  }

  return inject('contentStore', ...additionalStores)(StoryblokWrapper);
}

export default withStoryblok;
